// extracted by mini-css-extract-plugin
module.exports = {"ContactTagContainer":"ContactTag_ContactTagContainer__85_Px","Label":"ContactTag_Label___Z6Ow","ImageBox":"ContactTag_ImageBox__MKHZs"};